export function isCheckoutLoadedPath(rawPath: string): boolean {
  const path = rawPath.split(/[?#]/, 1)[0] || '/';
  if (/^\/checkout\/[0-9]+\/(?:success|failure)(?:\/|$)/.test(path)) return false;
  return /^\/(?:cart\/)?checkout(?:\/|$)/.test(path)
    || path === '/auth/signup/checkout';
}
